export default __webpack_public_path__ + "static/media/wave3-01.b8194f7e.svg";